import type { ReactNode } from "react";

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className ?? ""}`}
    >
      {icon && (
        <div className="mb-4 text-brand-muted" aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-brand-ink mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-brand-muted max-w-sm mb-5">{description}</p>
      )}
      {action}
    </div>
  );
}
